import { createSelector } from 'reselect';

const getAddress = state => state.address;

const getAddressDetails = state => getAddress(state).details;
const getAutocomplete = state => getAddress(state).autocomplete;

const AddressSelectors = {
    makeAutocomplete: createSelector([getAutocomplete], autocomplete => autocomplete),
    makeAddressList: createSelector([getAutocomplete], autocomplete => autocomplete.addressList),
    makeAddressDetails: createSelector([getAddressDetails], details => details),
};

export default AddressSelectors;
